import { Flex, Loader as AmplifyLoader, Text } from "@aws-amplify/ui-react";

/** Centered loading state — use for full-page or full-panel loads. */
export default ({ label = "Loading…" }: { label?: string }) => (
  <Flex
    direction="column"
    alignItems="center"
    justifyContent="center"
    gap="0.75rem"
    padding="3rem 1rem"
    width="100%"
  >
    <AmplifyLoader size="large" />
    <Text color="font.secondary">{label}</Text>
  </Flex>
);
